//
// EntryTextItem.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "./EntryTextItemSource";
import "../core/HorizontalAlignment";
import "@sas-dvr/ltjs-commons/styles/ScriptType";
import "./KeyFrameValueOptions";
import "../core/styles/TextAttributes";

var EntryTextItem = createModule("gtl::EntryTextItem", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        keyFrameValueOptions: 1,
        textAttributes: 1,
        hAlign: 4,
        scriptType: 4,
        source: 4,
        text: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default EntryTextItem;
